export class InvPartNumberDeftGeneral{
    id:number;
    store:string;
    partNumber:string;
    serial:string;
    creationDate:string;
    userId:number;
    active:boolean;    
    constructor (){}
}